import { useEffect, useState } from "react";
import { _Company, _Entailment, _single, _SystemPropertyOB } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_BOOLEAN, MASK_MONEY, MASK_TEXT_NOWRAP } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _GuideItemList, _GuideProjectLeft, _InvoiceTransportGuide, _NullifyTransport, _QuoteTransport, _ReleaseTransportGuide, _TransportGuide, _TransportGuideInfo, _TransportGuideItem } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { AccountantYear } from "../../../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { TransportServiceEditor } from "../TransportService/TransportServiceEditor";
import { TransportGuideState } from "./TransportGuideState";
import { SelectAccountantConceptCatalogForSalesInvoice } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectAccountantConceptCatalogForSalesInvoice";
import { GuideDocType } from "./GuideDocType";
import { FreightTypeEditor } from "../FreightType/FreightTypeEditor";
import { InputDate } from "../../../theme/Input/InputDate";
import { ProjectSelectEditor } from "../../../RemoteAbstractAction/editors/ProjectSelectEditor";
import { GoodsStateEditor } from "../GoodsState/GoodsStateEditor";
import { GoodsSupportEditor } from "../GoodsSupport/GoodsSupportEditor";
import { CashDeskAccountSelector } from "../../../erp/cellEditor/CashDeskAccount/CashDeskAccountSelector";
import { CitiesEditor } from "../Countries/Cities/CitiesEditor";
import { InvoiceToType } from "./InvoiceToType/InvoiceToType";
import './guia.css';
import { FileService } from "../../../../core/services/FileService";
import { VisorAnyDocument } from "../../../documents/VisorAnyDocument";
import { InputMoney } from "../../../theme/Input/InputMoney";
import useModal, { MODAL_LG, MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { useZebraPrinter } from "../../../system/zpl/useZebraPrinter";
import { useZplGuideGenerator } from "../../../system/zpl/useZplGuideGenerator";
import { EditorCompany } from "../../../erp/cellEditor/Company/EditorCompany";
import { BasicMultiSelectTable } from "../../../theme/Component/BasicMultiSelecTable";
import { EditorCargoManifest } from "../CargoManifest/EditorCargoManifest";
import { DropDown } from "../../../theme/Component/DropDown";
import { PiezesServices } from "./PiezesServices";
import { TransportGuideMetodo } from "./TransportGuideMetodo";
import { EditorTransportRouteByoffice } from "../TransportRoute/EditorTransportRouteByoffice";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { TransportGuidePaymentForm } from "./TransportGuidePaymentForm/TransportGuidePaymentForm";


export const TransportGuide = () => {

    const { instance, setBean, setLista, bean, lista } = useDataBean(_TransportGuide);

    const [infoLiquidate, setInfoLiquidate] = useState<any>({});

    const release = useDataBean(_ReleaseTransportGuide);
    const transinvoice = useDataBean(_InvoiceTransportGuide);
    const items = useDataBean(_TransportGuideItem);
    const props = useDataBean(_SystemPropertyOB)
    const GuideProjectLeft = useDataBean(_GuideProjectLeft)
    const infoGuide = useDataBean(_TransportGuideInfo);
    const quote = useDataBean(_QuoteTransport);
    const nullyfy = useDataBean(_NullifyTransport);
    const { instance: compInstance, lista: compLista, setLista: compSetLista } = useDataBean(_Company)
    const fileService = new FileService();
    const { print } = useZebraPrinter();
    const { generateGuideZpl } = useZplGuideGenerator()
    const paginador = usePaginator();
    const paginadorItems = usePaginator();
    const [projectLeft, setProjectLeft] = useState("");
    const [projectLeftName, setProjectLeftName] = useState("");
    const [company, setCompany] = useState<any>({});
    const [formato, setFormato] = useState<any>([]);
    const [listaResult, setListaResult] = useState<any[]>([]);
    const [type, settype] = useState<any>([]);
    const [sender, setSender] = useState<Record<string, unknown>>({});
    const [addressee, setAddressee] = useState<Record<string, unknown>>({});
    const [form, setForm] = useState<any>({
        Agency: null,
        AgencyName: null,
        FreightType: null,
        FreightTypeName: null,
        TransportService: null,
        TransportServiceName: null,
        TransportRoute: null,
        TransportRouteName: null,
        IDCities: null,
        SiteIDName: null,
        GoodsType: null,
        GoodsTypeName: null

    });
    const [Year, setYear] = useState<any>(_single.getCurrenYear())
    const [Month, setMonth] = useState<any>(_single.getCurrentMonth())
    const [GuideState, setGuideState] = useState<any>(null)
    const [Forinvoice, setForinvoice] = useState<any>(null)
    const [IdAcoountsupp, setIdAcoountsupp] = useState<any>(null)
    const [IdAcoountcutom, setIdAcoountcustom] = useState<any>(null)
    const [idCargoManifest, setidCargoManifest] = useState<any>(null)
    const [TransGuide, setTransGuide] = useState<any>(null)
    const [TransCode, setTransCode] = useState<any>(null)
    const [Doc, setDoc] = useState<any>(null)
    const [DocInfo, setDocInfo] = useState<any>(null)
    const [DocInfotre, setDocInfotre] = useState<any>(null)
    const [modalviewdoctre, setModalviewdoctre] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalmetodo, setModalmetodo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalviewdoc, setModalviewdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalviewpdf, setModalviewpdf] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });

    const modal = useModal("", MODAL_XL)
    const modalPrint = useModal("Imprimir guias", MODAL_XL)
    const modalPay = useModal("Metodos de Pago", MODAL_LG)

    const [modalservicepiezas, setModalservicepiezas] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalpiezas, setModalpiezas] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const defaultOffice = _single.getOffice();

    useEffect(() => {
        getLista();
    }, [paginador.page])

    useEffect(() => {
        if (bean.IDProject) {
            getTransportGuideProjectLeft();
        } else {
            setProjectLeftName("");
            setProjectLeft("");
        }
    }, [bean.IDProject]);

    useEffect(() => {
        if (
            (modal.modal.view &&
                bean.IDTransportGuide != null &&
                bean.TransportGuideDate != null)
        ) {
            getTransportGuideItemValues();
        }
    }, [bean.IDTransportGuide, modal.modal.view]);

    useEffect(() => {
        setBean(prev => ({
            ...prev,
            IDUBLPaymentMeansCode: null,
            PaymentMeansCode: ""
        }));
    }, [bean.UseProject]);

    useEffect(() => {
        props.instance.getSystemProperty("PRINT_PROPS_ZPL_GUIDE").then(
            (resp) => {
                if (resp.SystemValue) {
                    const pro = resp.SystemValue ? JSON.parse(resp.SystemValue) : {};
                    props.setBean(pro)
                    console.log(pro)
                }
            }
        ).catch(
            err => {
                toast.error("No se pudieron cargar las propiedades del sistema")
            }
        )

        compInstance.getCompanyCatalog(null).then(
            (resp: any) => {
                compSetLista(resp)
                if (resp.length === 1) {
                    setCompany(resp[0].DataBeanProperties)
                }
            }
        ).catch(err => { toast.error(err) })
    }, [])

    const renderUserAdressed = (item: any) => {
        let render =
            ` 
        <div>            
            <strong>NIT: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddresseeNit : 'NA'}</small><br />
            <strong>Contacto: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddresseeName : 'NA'}</small><br />            
            <strong>Dirección: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddressesAddress : 'NA'}</small><br />            
            <strong>Correo: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddresseeEmail : 'NA'}</small><br />            
            <strong>Telefono: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddresseeTel : 'NA'}</small><br />            
        </div>
        `
        return render;
    }

    const renderUserSender = (item: any) => {
        let render =
            ` 
        <div>            
            <strong>NIT: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountCustomerNit : 'NA'}</small><br />
            <strong>Contacto: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountCustomerName : 'NA'}</small><br />            
            <strong>Dirección: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountAddress : 'NA'}</small><br />            
            <strong>Correo: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountEmail : 'NA'}</small><br />            
            <strong>Telefono: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountTel : 'NA'}</small><br />            
        </div>
        `
        return render;
    }

    const getLista = () => {

        instance.getTransportGuideCatalog(Year, Month, idCargoManifest, IdAcoountcutom, IdAcoountsupp, defaultOffice.IDOffice, form.TransportRoute,
            form.TransportService, GuideState, Forinvoice, TransGuide, null, TransCode, form.IDCities, Doc, form.FreightType, null, paginador.page, 15).then(
                (resp: any) => {
                    if (resp) {
                        paginador.setPages(resp.NumberOfPages);
                        paginador.setRecords(resp.NumberOfPages * (15));
                        paginador.setRegiPerPage(15)
                        // setLista(resp.List)
                        let x = resp.List;
                        x.forEach((guide) => {
                            guide.DataBeanProperties.Rute = guide.DataBeanProperties.IDTransportRoute ? `${guide.DataBeanProperties.TransportDestinationOrigin ?? ""} - ${guide.DataBeanProperties.TransportDestinationDestinity ?? ""}` : "N/P";
                            guide.DataBeanProperties.EntityAdressed = renderUserAdressed(guide);
                            guide.DataBeanProperties.EntitySender = renderUserSender(guide);
                        });
                        setLista(x)
                    }
                }
            )

    }
    const create = () => {
        setBean({
            IDOffice: defaultOffice.IDOffice,
            TransportGuideDocType: 25,
            InvoiceToType: 26,
            InvoiceFreightType: 20,
            TransportGuideDate: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID(),

        });

        modal.open(`Agregar Guia de transporte`)
    }

    const editaItem = () => {
        instance.updateTransportGuide(bean).then(
            (resp: any) => {
                getLista();
                setBean(resp);
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const liquidateTransportGuide = () => {
        instance.liquidateTransportGuide(bean.IDTransportGuide, bean.TransportGuideDate, _single.getAccountID()).then(
            (resp: any) => {
                setModalpiezas({ ...modal, view: true, format: 'modal-lg' });
                getLista();
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const getFileType = (mediaName: string) => {
        let fileType = mediaName.split('.').pop()?.toLowerCase();
        return fileType;
    }

    const sendTransportGuide = () => {
        instance.sendTransportGuide(bean.IDTransportGuide, bean.TransportGuideDate, _single.getAccountID()).then(
            (resp: any) => {

                if (Array.isArray(resp) && resp.length > 0) {
                    let data = resp[0].DataBeanProperties;
                    if (data.MediaContext) {
                        const url = fileService.getUrlFile(data.MediaContext, data.Media);
                        const type = getFileType(data.Media);
                        settype(type)
                        setFormato(url)
                        setModalviewpdf({ ...modalviewpdf, "view": true });
                    } else {
                        toast.warning('No se ha generado documento');
                    }
                } else {
                    toast.warning('No se ha generado documento');
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const invoiceTransportGuide = () => {
        transinvoice.instance.invoiceTransportGuide(bean.IDTransportGuide, bean.TransportGuideDate, _single.getAccountID()).then(
            (resp: any) => {
                if (resp.DocumentURL) {
                    console.log(resp)
                    setDocInfo(resp.DocumentURL);
                    setModalviewdoc({ ...modalviewdoc, "view": true })
                } else {
                    toast.error('Sin Documento');
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const nullifyTransportGuide = () => {
        nullyfy.instance.nullifyTransportGuide(bean.IDTransportGuide, bean.TransportGuideDate, _single.getAccountID()).then(
            (resp: any) => {
                if (resp.DocumentURL) {
                    console.log(resp)
                    setDocInfotre(resp.DocumentURL);
                    setModalviewdoctre({ ...modalviewdoctre, "view": true })
                } else {
                    toast.error('Sin Documento');
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const getItems = () => {
        items.instance.getTransportGuideItemCatalog(bean.IDTransportGuide, bean.TransportGuideDate, paginadorItems.page, 15).then(
            (resp) => {
                items.setLista(resp.List);
                modalPrint.open()
            }
        ).catch(err => {
            "no se pudo traer la informacion de las piezas";
            console.log(err)
        })
    }
    const quoteTransportGuide = () => {
        quote.instance.quoteTransportGuide(bean.IDTransportGuide, bean.TransportGuideDate, _single.getAccountID()).then(
            (resp) => {
                console.log(resp)
            }
        ).catch(err => {
            toast.error(err);
            console.log(err)
        })
    }
    const releaseTransportGuideFromManifestCargo = () => {
        release.instance.releaseTransportGuideFromManifestCargo(bean.IDTransportGuide, bean.TransportGuideDate).then(
            (resp) => {
                console.log(resp)
                getLista()
                // toast.success('Realizado')
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    const getTransportGuideItemValues = () => {
        infoGuide.instance.getTransportGuideItemValues(bean.IDTransportGuide, bean.TransportGuideDate).then(
            (resp) => {
                setInfoLiquidate(resp)

                // toast.success('Realizado');
            }
        ).catch(err => {
            toast.error(err);
        });
    };

    const getTransportGuideProjectLeft = () => {
        GuideProjectLeft.instance
            .getTransportGuideProjectLeft(bean.IDProject)
            .then((resp) => {
                setProjectLeftName(resp.AccountantIDName)
                setProjectLeft(resp.ProjectLeftValue);
            })
            .catch(err => {
                toast.error(err)
            })
    }

    const head = [
        { title: 'ID', property: 'IDTransportGuide', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Fecha Emisión', property: 'TransportGuideDate', visible: true },
        { title: 'Código Guia', property: 'TransportGuideCode', visible: true },
        { title: 'Consecutivo GUIA', property: 'TransportGuideConsecutive', visible: true },
        { title: 'Valor Guía', property: 'TotalPayment', visible: true, mask: MASK_MONEY },
        { title: 'Valor Declarado', property: 'GoodsValue', visible: true, mask: MASK_MONEY },
        { title: 'Tipo Documento', property: 'TransportGuideDocTypeName', visible: true },
        { title: 'Utiliza Convenio', property: 'UseProject', visible: true, mask: MASK_BOOLEAN },
        { title: 'Convenio', property: 'ProjectName', visible: true },
        { title: 'Facturar a', property: 'InvoiceToTypeName', visible: true },
        { title: 'Cliente', property: 'EntitySender', visible: true, Style: { minWidth: "250px" } },
        { title: 'Conctacto Cliente', property: 'EntityAdressed', visible: true, Style: { minWidth: "250px" } },
        { title: 'Servicio de Entrega', property: 'TransportServiceName', visible: true },
        { title: 'Tipo Facturación', property: 'InvoiceFreightTypeName', visible: true },
        { title: 'Número de Piezas', property: 'PiecesNumber', visible: true },
        { title: 'Ruta de Carga', property: 'Rute', visible: true, Style: { minWidth: "150px" } },
        { title: 'Formas de Pago', property: 'PaymentMeansID', visible: true },
        { title: 'Métodos de Pago', property: 'PaymentMeansCode', visible: true },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true },
        { title: 'Total Pagos', property: 'TotalPayment', visible: true, mask: MASK_MONEY },
        { title: 'Estado de Carga', property: 'GoodsStateName', visible: true },
        { title: 'Soporte de Carga', property: 'GoodsSupportName', visible: true },
        { title: 'Tipo de Carga', property: 'FreightTypeName', visible: true },
        { title: 'Peso (KG)', property: 'WeightKg', visible: true },
        { title: 'Longitud', property: 'LongLength', visible: true },
        { title: 'Alto', property: 'HightLength', visible: true },
        { title: 'Ancho', property: 'WidthLength', visible: true },
        { title: 'Observaciones Carga', property: 'GoodsDescription', visible: true },
        { title: 'Oficina', property: 'OfficeName', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Caja', property: 'CashDeskAccountName', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
    ]

    const headItems = [
        { title: 'ID', property: 'IDTransportGuideItem', visible: true },
        { title: 'Estado de Carga', property: 'GoodsStateName', visible: true },
        { title: 'Soporte de Carga', property: 'GoodsSupportName', visible: true },
        { title: 'Tipo de Carga', property: 'GoodsTypeName', visible: true },
        { title: 'Peso (Kg)', property: 'WeightKg', visible: true },
        { title: 'P/Real (Kg)', property: 'WeightKgReal', visible: true },
        { title: 'Largo (cm)', property: 'LongLength', visible: true },
        { title: 'Ancho (cm)', property: 'WidthLength', visible: true },
        { title: 'Alto (cm)', property: 'HightLength', visible: true },
        { title: 'Volumen', property: 'Volume', visible: true },
        { title: 'Descripción Pieza', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar Guia de transporte`) } },
            { titulo: 'Liberar Guía de transporte de manifiesto de carga', icono: 'ri-arrow-go-back-line', visible: _single.canEdit(), evento: () => { releaseTransportGuideFromManifestCargo() } },
            { titulo: 'Liquidar Guía', icono: 'ri-task-line', visible: _single.canEdit(), evento: () => { liquidateTransportGuide() } },
            { titulo: 'Generar Guía', icono: 'ri-todo-line', visible: _single.canEdit(), evento: () => { sendTransportGuide() } },
            { titulo: 'Metodos de Pago', icono: 'ri-money-dollar-circle-line', visible: _single.canEdit(), evento: () => { modalPay.open(); } },
            { titulo: 'Facturar Guia de Transporte', icono: 'ri-bill-fill', visible: _single.canEdit(), evento: () => { invoiceTransportGuide() } },
            { titulo: 'Cotizar guía de transporte', icono: 'ri-file-edit-fill', visible: _single.canEdit(), evento: () => { quoteTransportGuide() } },
            { titulo: 'Anular Guía De Transporte', icono: 'ri-chat-delete-fill', visible: _single.canEdit(), evento: () => { nullifyTransportGuide() } },
            { titulo: 'Detalle de Piezas', icono: 'ri-coupon-2-fill', visible: _single.canEdit(), evento: () => { setModalpiezas({ ...modalpiezas, "view": true }) } },
            { titulo: 'Servicios Adicionales', icono: 'ri-send-plane-2-line', visible: _single.canEdit(), evento: () => { setModalservicepiezas({ ...modalservicepiezas, "view": true }) } },
            { titulo: 'Imprimir Guias', icono: 'ri-printer-line', visible: _single.canEdit(), evento: () => { getItems(); } },
            // { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const updateListaResult = (newListaResult: any[]) => {
        setListaResult(prev => {
            const merged = newListaResult.map(item => {
                const found = prev.find(x => x.DataBeanProperties.IDTransportGuideItem === item.DataBeanProperties.IDTransportGuideItem);
                return {
                    ...item,
                    quantity: found?.quantity ?? 1
                };
            });
            return merged;
        });
    };

    const printGuide = async (pieceList: any[]) => {
        if (!props.bean) return;
        if (!pieceList?.length) {
            toast.warning("No hay piezas seleccionadas");
            return;
        }

        try {

            toast.info("Generando impresión...");

            let zplBatch = "";
            for (const item of pieceList) {
                const data = item.DataBeanProperties;
                const zpl = await generateGuideZpl(
                    {
                        header: {
                            logoUrl: fileService.getUrlFile(
                                company.LogoImageMediaContext,
                                company.LogoImageMedia
                            ),
                            barcode: String(bean.IDTransportGuide ?? "")
                        },
                        route: bean.Rute ?? "N/P",
                        weight: data.WeightKg ?? 0,
                        recipient: {
                            name: bean.AccountAddresseeName ?? "",
                            tel: bean.AccountAddresseeTel ?? "",
                            address: bean.AccountAddressesAddress ?? ""
                        },
                        sender: {
                            name: bean.AccountCustomerName ?? "",
                            tel: bean.AccountTel ?? "",
                            address: bean.AccountAddress ?? ""
                        },
                        state: data.GoodsStateName ?? ""
                    },
                    { ...props.bean }
                );
                zplBatch += zpl;
            }

            await print(zplBatch);
            toast.success("Impresión enviada correctamente");
            modalPrint.close();

        } catch (err) {
            console.error(err);
            toast.error("Error al imprimir");
        }
    };

    const actionsDropDown = [
        { id: 1, name: 'Imprimir todas las piezas', permiso: null, activo: true },

    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            items.instance.getTransportGuideItemCatalog(bean.IDTransportGuide, bean.TransportGuideDate, null, null).then(
                                (resp) => {
                                    if (resp.List.length > 0) {
                                        printGuide(resp.List);
                                    } else {
                                        toast.error("Sin piezas para imprimir")
                                    }
                                }
                            ).catch(err => {
                                "no se pudo traer la informacion de las piezas";
                                console.log(err)
                            })
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    const paymentType = bean.UseProject ? 4 : 3;

    const colSize = Object.keys(infoLiquidate).length > 0 ? "col-md-3" : "col-md-12";

    const modalReturned = () => {
        return (
            <>
                <Modal modal={modalmetodo} updateModal={setModalmetodo}>
                    <div className="row">
                        <div className="col-md-12">
                            <TransportGuideMetodo />
                        </div>
                    </div>

                </Modal>


                <Modal modal={modalviewpdf} updateModal={setModalviewpdf}>
                    <div className="row">
                        <div className="col-md-12">
                            <VisorAnyDocument url={formato} type={type} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalpiezas} updateModal={setModalpiezas} evenOnClose={() => { getTransportGuideItemValues() }}>
                    <PiezesServices view={true} idTransportGuide={bean.IDTransportGuide} transportGuideDate={bean.TransportGuideDate} />
                </Modal>

                <Modal modal={modalservicepiezas} updateModal={setModalservicepiezas}>
                    <PiezesServices idOffice={defaultOffice.IDOffice} view={false} idTransportGuide={bean.IDTransportGuide} transportGuideDate={bean.TransportGuideDate} />
                </Modal>

                <Modal modal={modalPay.modal} updateModal={modalPay.setModal}>
                    <TransportGuidePaymentForm TransportGuide={bean} />
                </Modal>

                <Modal modal={modalviewdoc} updateModal={setModalviewdoc}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer list={DocInfo} />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalviewdoctre} updateModal={setModalviewdoctre}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer list={DocInfotre} />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalPrint.modal} updateModal={modalPrint.setModal} eventModal={() => { printGuide(listaResult) }}>
                    <div className="row">
                        <div className="col-md-12">
                            <strong>Confirmar impresion de guia</strong>
                        </div>
                        {compLista.length == 1 ?
                            null
                            :
                            <div className="col-md-4">
                                <EditorCompany idSelector={company.IDCompany} onChange={(e) => { setCompany(e) }} label="Compañia" returnType="Object" />
                            </div>
                        }
                        <div className="col-md-12">
                            <BasicMultiSelectTable headButtons={buttons()} body={items.lista} bodyResult={listaResult} head={headItems} keyId="IDTransportGuideItem" updateValues={({ bodyResult }) => { updateListaResult(bodyResult) }} />
                        </div>
                    </div>
                </ModalConfirm>
            </>
        )
    }

    return (
        <BasicPage titulo="Guias de Transporte">
            <div className="row">
                <div className="col-md-6 p-3">
                    *ID Oficina:{defaultOffice.IDOffice}-{defaultOffice.OfficeName}
                </div>
                {/* <div className="col-md-6">
                    <CashDeskAccountSelector id={cashID} office={defaultOffice.IDOffice} onchange={(e) => { setCashID(e) }} idAccount={_single.getAccountID()} />
                </div> */}
                <hr className="mt-4"></hr>
                <div className="col-md-6">
                    <AccountantYear idSelector={Year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-6">
                    <MonthEditorbyconst idSelector={Month} onChange={(e) => { setMonth(e) }} />
                </div>
                <div className="col-md-6">
                    <EditorCargoManifest idSelector={idCargoManifest} onChange={(e) => { setidCargoManifest(e) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor label="Cliente" idAccount={IdAcoountcutom} onChange={(e) => { setIdAcoountcustom(e.IDAccount) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor label="Proveedor" idAccount={IdAcoountsupp} onChange={(e) => { setIdAcoountsupp(e.IDAccount) }} />
                </div>
                <div className="col-md-6">
                    <EditorTransportRouteByoffice office={defaultOffice.IDOffice} idSelector={form.TransportRoute} onChange={(e) => { setForm({ ...form, "TransportRoute": e.IDTransportRoute }) }} returnType="Object" />
                </div>
                <div className="col-md-6">
                    <TransportServiceEditor render={form.TransportServiceName} idSelector={form.TransportService} onChange={(e) => { setForm({ ...form, "TransportService": e.IDTransportService, "TransportServiceName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-6">
                    <TransportGuideState idSelector={GuideState} onChange={(e) => { setGuideState(e) }} />
                </div>
                <div className="col-md-6">
                    <SelectAccountantConceptCatalogForSalesInvoice idSelector={Forinvoice} onChange={(e) => { setForinvoice(e) }} />
                </div>
                <div className="col-md-6">
                    <label>ID Guía de Transporte</label>
                    <input type="text" className="form-control" value={TransGuide} onChange={(e: any) => { setTransGuide(parseInt(e)) }} />
                </div>
                <div className="col-md-6">
                    <label>Código de Guía de Transporte</label>
                    <input type="text" className="form-control" value={TransCode} onChange={(e: any) => { setTransCode(parseInt(e)) }} />
                </div>
                <div className="col-md-6">
                    <CitiesEditor render={form.SiteIDName} idSelector={form.IDCities} onChange={(e) => { setForm({ ...form, "IDCities": e.IDCities, "SiteIDName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-6">
                    <GuideDocType idSelector={Doc} onChange={(e) => { setDoc(e) }} />
                </div>
                <div className="col-md-6">
                    <FreightTypeEditor render={form.FreightTypeName} idSelector={form.FreightType} onChange={(e) => { setForm({ ...form, "FreightType": e.IDFreightType, "FreightTypeName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={editaItem} evenOnClose={() => { setSender({}); setInfoLiquidate({}); setAddressee({}) }} onSubmitLabel={bean.IDTransportGuide ? "Actualizar" : "Agregar"} buttonsAddFooter={
                        <>
                            {bean.IDTransportGuide &&
                                <BasicButton eventClick={() => { quoteTransportGuide() }} icon="" clase="success" children={`Cotizar Guia`} />
                            }
                            {bean.IDTransportGuide &&
                                <BasicButton eventClick={() => { invoiceTransportGuide() }} icon="" clase="success" children={`Facturar Guia`} />
                            }
                            {bean.IDTransportGuide &&
                                <BasicButton eventClick={() => { modalPay.open() }} icon="" clase="success" children={`Metodos de pago`} />
                            }
                            {bean.IDTransportGuide &&
                                <BasicButton eventClick={() => { sendTransportGuide() }} icon="" clase="success" children={`Generar Guia`} />
                            }
                            {bean.IDTransportGuide &&
                                <BasicButton eventClick={() => { liquidateTransportGuide() }} icon="" clase="success" children={`Liquidar Guia`} />
                            }
                            {bean.IDTransportGuide &&
                                <BasicButton eventClick={() => { setModalpiezas({ ...modalpiezas, "view": true }) }} icon="" clase="success" children={`Detalle de Piezas`} />
                            }
                            {bean.IDTransportGuide &&
                                <BasicButton eventClick={() => { setModalservicepiezas({ ...modalservicepiezas, "view": true }) }} icon="" clase="success" children={`Servicios Adicionales`} />
                            }
                        </>
                    } >
                        <div className="row tg-form guide-transport">

                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <strong>Oficina:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${defaultOffice.IDOffice} - ${defaultOffice.OfficeName}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Manifiesto de Carga:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: bean.IDCargoManifest }}></div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <InputDate name="" value={bean.TransportGuideDate} label="Fecha de Emisión" />
                                    </div>

                                    <div className="col-md-3">
                                        <GuideDocType idSelector={bean.TransportGuideDocType} onChange={(e) => {
                                            setBean({
                                                ...bean,
                                                TransportGuideDocType: e
                                            });
                                        }}
                                        />
                                    </div>

                                    <div className="col-md-3">
                                        <InvoiceToType
                                            idSelector={bean.InvoiceToType}
                                            onChange={(e) => {
                                                setBean({
                                                    ...bean,
                                                    InvoiceToType: e
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <CashDeskAccountSelector id={bean.IDCashDeskAccount} office={defaultOffice.IDOffice} onchange={(e) => { setBean({ ...bean, IDCashDeskAccount: e }) }} idAccount={_single.getAccountID()} />
                                    </div>
                                    {bean.TransportGuideDocType === 24 && (
                                        <div className="col-md-6">
                                            <label className="tg-label">Numeración Fisica</label>
                                            <input
                                                className="form-control tg-input"
                                                value={bean.TransportGuideNum}
                                                onChange={(e) => {
                                                    setBean({ ...bean, TransportGuideNum: e.target.value });
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div className="col-md-6">
                                        <EditorTransportRouteByoffice
                                            office={defaultOffice.IDOffice}
                                            label="Ruta de Carga"
                                            render={bean.Rute}
                                            idSelector={bean.IDTransportRoute}
                                            onChange={(e) => { setBean({ ...bean, IDTransportRoute: e.IDTransportRoute, }); }}
                                            returnType="Object"
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <TransportServiceEditor
                                            label="Servicio de Entrega"
                                            render={bean.TransportServiceName}
                                            idSelector={bean.IDTransportService}
                                            onChange={(e) =>
                                                setBean({
                                                    ...bean,
                                                    IDTransportService: e.IDTransportService,
                                                    TransportServiceName: e.Name
                                                })
                                            }
                                            returnType="Object"
                                        />
                                    </div>
                                </div>

                                <hr />

                                <div className="row align-items-stretch">

                                    <div className="col-md-4">
                                        <div className="tg-card">
                                            <div className="tg-card-label">REMITENTE</div>

                                            <div className="tg-card-content">
                                                <div className="tg-section">

                                                    <div className="tg-field">
                                                        <label className="tg-label">Usa Convenio</label>
                                                        <BasicSwitch
                                                            label=" "
                                                            estado={bean.UseProject}
                                                            eventChange={(e) =>
                                                                setBean({
                                                                    ...bean,
                                                                    UseProject: e
                                                                })
                                                            }
                                                        />
                                                    </div>

                                                    {bean.UseProject && (
                                                        <div className="tg-field">
                                                            <label className="tg-label">Convenio</label>
                                                            <ProjectSelectEditor
                                                                label=""
                                                                render={bean.ProjectName}
                                                                idSelector={bean.IDProject}
                                                                onChange={(e) =>
                                                                    setBean({
                                                                        ...bean,
                                                                        IDProject: e.IDProject,
                                                                        ProjectName: e.Name,
                                                                        IDAccountCustomer: e.IDAccount
                                                                    })
                                                                }
                                                                returnType="Object"
                                                            />
                                                        </div>
                                                    )}

                                                    {bean.IDProject && (
                                                        <>
                                                            <div className="tg-field">
                                                                <label className="tg-label">Nombre</label>
                                                                <input
                                                                    className="form-control tg-input"
                                                                    value={projectLeftName}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="tg-field">
                                                                <InputMoney _label='Saldo' _value={projectLeft} onChange={(e: any) => { setProjectLeft(e.target.value) }} readonly />
                                                            </div>
                                                        </>
                                                    )}
                                                    <div className="tg-field">
                                                        <label className="tg-label">Nombre Remitente</label>
                                                        <AccountEditor
                                                            label=""
                                                            canCreate
                                                            disabled={bean.UseProject}   // 👈 AQUÍ
                                                            idAccount={bean.IDAccountCustomer}
                                                            onChange={(e) => {
                                                                setBean({
                                                                    ...bean,
                                                                    IDAccountCustomer: e.IDAccount
                                                                });
                                                                setSender({
                                                                    Nit: e.Nit ?? 0,
                                                                    address: e.address ?? "N/P",
                                                                    Tel: e.Tel ?? "N/P",
                                                                    eMail: e.eMail ?? "N/P"
                                                                });
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="tg-field">
                                                        <label className="tg-label">Nit Remitente</label>
                                                        <input
                                                            className="form-control tg-input"
                                                            value={
                                                                sender.Nit
                                                                    ? sender.Nit
                                                                    : bean.AccountCustomerNit
                                                            }
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="tg-field">
                                                        <label className="tg-label">Dirección</label>
                                                        <input
                                                            className="form-control tg-input"
                                                            value={
                                                                sender.address
                                                                    ? sender.address
                                                                    : bean.AccountAddress
                                                            }
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="tg-field">
                                                        <label className="tg-label">Teléfono</label>
                                                        <input
                                                            className="form-control tg-input"
                                                            value={
                                                                sender.Tel
                                                                    ? sender.Tel
                                                                    : bean.AccountTel
                                                            }
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="tg-field">
                                                        <label className="tg-label">Correo Electrónico</label>
                                                        <input
                                                            className="form-control tg-input"
                                                            value={
                                                                sender.eMail
                                                                    ? sender.eMail
                                                                    : bean.eMail
                                                            }
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* DESTINATARIO */}
                                    <div className="col-md-4">
                                        <div className="tg-card">
                                            <div className="tg-card-label">DESTINATARIO</div>

                                            <div className="tg-card-content">
                                                <div className="tg-section">

                                                    <div className="tg-field">
                                                        <label className="tg-label">Nombre Destinatario</label>
                                                        <AccountEditor
                                                            label=""
                                                            canCreate
                                                            idAccount={bean.IDAccountAddressee}
                                                            onChange={(e) => {
                                                                setBean({
                                                                    ...bean,
                                                                    IDAccountAddressee: e.IDAccount,
                                                                    Identity: e.Nit
                                                                });
                                                                setAddressee({
                                                                    Nit: e.Nit ?? 0,
                                                                    address: e.address ?? "N/P",
                                                                    Tel: e.Tel ?? "N/P",
                                                                    eMail: e.eMail ?? "N/P"
                                                                });
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="tg-field">
                                                        <label className="tg-label">Nit Destinatario</label>
                                                        <input
                                                            className="form-control tg-input"
                                                            value={
                                                                addressee.Nit
                                                                    ? addressee.Nit
                                                                    : bean.AccountAddresseeNit
                                                            }
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="tg-field">
                                                        <label className="tg-label">Dirección Cliente</label>
                                                        <input
                                                            className="form-control tg-input"
                                                            value={
                                                                addressee.address
                                                                    ? addressee.address
                                                                    : bean.AccountAddressesAddress
                                                            }
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="tg-field">
                                                        <label className="tg-label">Teléfono</label>
                                                        <input
                                                            className="form-control tg-input"
                                                            value={
                                                                addressee.Tel
                                                                    ? addressee.Tel
                                                                    : bean.AccountAddresseeTel
                                                            }
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="tg-field">
                                                        <label className="tg-label">Correo Electrónico</label>
                                                        <input
                                                            className="form-control tg-input"
                                                            value={
                                                                addressee.eMail
                                                                    ? addressee.eMail
                                                                    : bean.AccountAddresseeEmail
                                                            }
                                                            readOnly
                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {Object.keys(infoLiquidate).length > 0 && (
                                        <div className="col-md-4">
                                            <div className="tg-card">

                                                <div className="tg-card-label">LIQUIDACION DE GUIA</div>

                                                <div className="tg-card-content">
                                                    <div className="tg-section">

                                                        <div className="tg-field">
                                                            <label className="tg-label">Peso Total (Kg)</label>
                                                            <input
                                                                className="form-control tg-input"
                                                                value={infoLiquidate.WeightKg ?? "N/P"}
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="tg-field">
                                                            <label className="tg-label">Volumen Total</label>
                                                            <input
                                                                className="form-control tg-input"
                                                                value={infoLiquidate.Volume ?? "N/P"}
                                                                readOnly
                                                            />
                                                        </div>

                                                        <div className="tg-field">
                                                            <label className="tg-label">Flete</label>
                                                            <input
                                                                className="form-control tg-input"
                                                                value={infoLiquidate.TotalAmount?.toLocaleString() ?? "N/P"}
                                                                readOnly
                                                            />
                                                        </div>

                                                        <div className="tg-field">
                                                            <label className="tg-label">Seguro</label>
                                                            <input
                                                                className="form-control tg-input"
                                                                value={infoLiquidate.PolicyValue?.toLocaleString() ?? "N/P"}
                                                                readOnly
                                                            />
                                                        </div>

                                                        <div className="tg-field">
                                                            <label className="tg-label">Otros</label>
                                                            <input
                                                                className="form-control tg-input"
                                                                value={infoLiquidate.OthersValue?.toLocaleString() ?? "N/P"}
                                                                readOnly
                                                            />
                                                        </div>

                                                        <div className="tg-field">
                                                            <label className="tg-label">Descuentos</label>
                                                            <input
                                                                className="form-control tg-input"
                                                                value={infoLiquidate.DiscountAmount?.toLocaleString() ?? "N/P"}
                                                                readOnly
                                                            />
                                                        </div>

                                                        <div className="tg-field">
                                                            <label className="tg-label">Total</label>
                                                            <input
                                                                className="form-control tg-input fw-bold"
                                                                value={infoLiquidate.TotalPayment?.toLocaleString() ?? "N/P"}
                                                                readOnly
                                                            />
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    )}


                                    <div className={Object.keys(infoLiquidate).length > 0 ? "col-md-12" : "col-md-4"}>
                                        <div className="row">

                                            <div className={colSize}>
                                                <label>Longitud</label>
                                                <input type="number" className="form-control" value={bean.LongLength} onChange={(e) => {
                                                    const valor = e.target.value ? parseFloat(e.target.value) : null;
                                                    setBean({ ...bean, LongLength: valor })
                                                }} />
                                            </div>

                                            <div className={colSize}>
                                                <label>Alto</label>
                                                <input type="number" className="form-control" value={bean.HightLength} onChange={(e) => {
                                                    const valor = e.target.value ? parseFloat(e.target.value) : null;
                                                    setBean({ ...bean, HightLength: valor })
                                                }} />
                                            </div>

                                            <div className={colSize}>
                                                <label>Ancho</label>
                                                <input type="number" className="form-control" value={bean.WidthLength} onChange={(e) => {
                                                    const valor = e.target.value ? parseFloat(e.target.value) : null;
                                                    setBean({ ...bean, WidthLength: valor })
                                                }} />
                                            </div>

                                            <div className={colSize}>
                                                <GoodsStateEditor
                                                    render={bean.GoodsStateName}
                                                    idSelector={bean.IDGoodsState}
                                                    onChange={(e) =>
                                                        setBean({
                                                            ...bean,
                                                            IDGoodsState: e.IDGoodsState,
                                                            GoodsStateName: e.Name
                                                        })
                                                    }
                                                    returnType="Object"
                                                />
                                            </div>

                                            <div className={colSize}>
                                                <FreightTypeEditor
                                                    render={bean.FreightTypeName}
                                                    idSelector={bean.IDFreightType}
                                                    onChange={(e) =>
                                                        setBean({
                                                            ...bean,
                                                            IDFreightType: e.IDFreightType,
                                                            FreightTypeName: e.Name
                                                        })
                                                    }
                                                    returnType="Object"
                                                />
                                            </div>

                                            <div className={colSize}>
                                                <GoodsSupportEditor
                                                    render={bean.GoodsSupportName}
                                                    idSelector={bean.IDGoodsSupport}
                                                    onChange={(e) =>
                                                        setBean({
                                                            ...bean,
                                                            IDGoodsSupport: e.IDGoodsSupport,
                                                            GoodsSupportName: e.Name
                                                        })
                                                    }
                                                    returnType="Object"
                                                />
                                            </div>

                                            <div className={colSize}>
                                                <InputMoney
                                                    _value={bean.GoodsValue}
                                                    onChange={(e) =>
                                                        setBean({
                                                            ...bean,
                                                            GoodsValue: e
                                                        })
                                                    }
                                                    _label="Valor Declarado"
                                                />
                                            </div>

                                        </div>
                                    </div>

                                </div>

                                <hr />

                                <hr />

                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Observaciones Carga</label>
                                        <textarea
                                            className="form-control tg-textarea"
                                            name="GoodsDescription"
                                            value={bean.GoodsDescription}
                                            onChange={(e) =>
                                                setBean({
                                                    ...bean,
                                                    GoodsDescription: e.target.value
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label>Observaciones</label>
                                        <textarea
                                            className="form-control tg-textarea"
                                            name="Descripción"
                                            value={bean.Description}
                                            onChange={(e) =>
                                                setBean({
                                                    ...bean,
                                                    Description: e.target.value
                                                })
                                            }
                                        />
                                    </div>

                                </div>

                            </div>
                        </div>
                        {modalReturned()}
                    </Modal>

                    {modalReturned()}
                </div>
            </div>
        </BasicPage>
    )
}